"use client";

import { c as _c } from "react/compiler-runtime";
import { useRouter } from "next/navigation";
import { useOpenAuthorizationTracking } from "@/src/hooks/use-open-authorization-tracking";
import { toast } from "@/src/hooks/use-toast";
import { selectReferralAuthTrackingPriorAuthorization } from "@/src/lib/prior-authorization/referral-auth-prior-authorization-selection";
import type { PriorAuthorization } from "@/src/models/documents/prior-authorization/prior-authorization";
export function useReferralAuthOpenAuthorization(t0) {
  const $ = _c(9);
  const {
    taskId,
    taskPriorAuthorization,
    linkedPriorAuthorizations
  } = t0;
  const router = useRouter();
  const {
    openAuthorizationTrackingSession,
    isOpening
  } = useOpenAuthorizationTracking();
  let t1;
  if ($[0] !== linkedPriorAuthorizations || $[1] !== openAuthorizationTrackingSession || $[2] !== router || $[3] !== taskId || $[4] !== taskPriorAuthorization) {
    t1 = async () => {
      const authorization = selectReferralAuthTrackingPriorAuthorization(linkedPriorAuthorizations, taskPriorAuthorization);
      if (!authorization?.displayId) {
        toast({
          title: "No authorization found",
          description: "Save authorization details from intake before opening the Authorizations tab.",
          variant: "destructive"
        });
        return;
      }
      const ok = await openAuthorizationTrackingSession({
        authDisplayId: authorization.displayId,
        taskId
      });
      if (ok) {
        router.push(`/authorizations/${authorization.displayId}/comms`);
      }
    };
    $[0] = linkedPriorAuthorizations;
    $[1] = openAuthorizationTrackingSession;
    $[2] = router;
    $[3] = taskId;
    $[4] = taskPriorAuthorization;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const handleOpenAuthorization = t1;
  let t2;
  if ($[6] !== handleOpenAuthorization || $[7] !== isOpening) {
    t2 = {
      handleOpenAuthorization,
      isOpeningAuthorization: isOpening
    };
    $[6] = handleOpenAuthorization;
    $[7] = isOpening;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}